import { prop, uniq } from 'ramda';
import { handleActions } from 'redux-actions';

import { normalizeBy } from 'utils';

import * as types from './actionTypes';

export const initialState = {
	byId: {},
	keyWindows: [],
};

const reducerMap = {
	[types.SET_DATA]: (state, { payload }) => {
		const { keyWindow, data } = payload;
		return {
			...state,
			byId: {
				...state.byId,
				...normalizeBy(data, 'id'),
			},
			keyWindows: uniq([...state.keyWindows, keyWindow]),
			[keyWindow]: data.map(prop('id')),
		};
	},
	[types.APPEND_DATA]: (state, { payload }) => {
		const { keyWindow, data } = payload;
		return {
			...state,
			byId: {
				...state.byId,
				...normalizeBy(data, 'id'),
			},
			keyWindows: uniq([...state.keyWindows, keyWindow]),
			[keyWindow]: [...state[keyWindow], ...data.map(prop('id'))],
		};
	},
	[types.RESET]: (state, { payload }) => {
		const { keyWindow } = payload;
		return {
			...state,
			[keyWindow]: [],
		};
	},
	[types.RESET_ALL]: () => initialState,
};

export default handleActions(reducerMap, initialState);
